import { useEffect, useState } from "react";
import { Image } from "antd";
import GOVCO from "../../../assets/landing/Logo.png";
import Escudo from "../../../assets/landing/Escudo.png";
import EscudoAlcaldiaBlanco from "../../../assets/landing/logo3.png";
import "./header.style.scss";
import { useNavigate } from "react-router";
import Buscador_icon from "../../../assets/Buscador.svg";
import { HeaderMobile } from "./headerMobile";
import { NavLink } from "react-router-dom";
import { FaHome, FaUsers, FaBookOpen, FaCalendarAlt, FaChalkboardTeacher, FaHandPointUp, FaClipboardList } from "react-icons/fa";
import { Tooltip } from 'antd';


export const HeaderScc = () => {
  const navigate = useNavigate();
  const goLogin = (): void => {
    navigate("/login");
  };

  const [isLogged, setIsLogged] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem("user");
    setIsLogged(!!user);
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <header className="navbar sticky2">
      <div className="navbar-container">
        <nav className={`navbar-links ${isOpen ? "active" : ""}`}>
          <Tooltip placement="bottom" title="Consulta las convocatorias abiertas para participar en procesos de fomento y estímulo al arte y la cultura.">
            <NavLink
              to="/"
              className={({ isActive }) => isActive ? "selected nav-item" : "nav-item"}
            >
              <FaHome className="nav-icon" />
              <span>Convocatorias</span>
            </NavLink>
          </Tooltip>
          <Tooltip placement="bottom" title="Conoce a los artistas, colectivos y entidades que han sido seleccionados en nuestras convocatorias.">
            <NavLink
              to="/beneficiarios"
              className={({ isActive }) => isActive ? "selected nav-item" : "nav-item"}
            >
              <FaUsers className="nav-icon" />
              <span>Beneficiarios</span>
            </NavLink>
          </Tooltip>
          <Tooltip placement="bottom" title="Explora la programación de actividades, eventos y presentaciones culturales en tu territorio.">
            <NavLink
              to="/agenda"
              className={({ isActive }) => isActive ? "selected nav-item" : "nav-item"}
            >
              <FaCalendarAlt className="nav-icon" />
              <span>Agenda cultural</span>
            </NavLink>
          </Tooltip>
          <Tooltip placement="bottom" title="Accede a espacios de formación, acompañamiento y fortalecimiento de capacidades para la formulación de proyectos culturales.">
            <NavLink
              to="/mentorias"
              className={({ isActive }) => isActive ? "selected nav-item" : "nav-item"}
            >
              <FaChalkboardTeacher className="nav-icon" />
              <span>Mentorías</span>
            </NavLink>
          </Tooltip>
          <Tooltip placement="bottom" title="Inscripciones a invitaciones y demás concursos que no son estímulos.">
            <NavLink
              to="/form"
              className={({ isActive }) => isActive ? "selected nav-item" : "nav-item"}
            >
              <FaClipboardList className="nav-icon" />
              <span>Formularios</span>
            </NavLink>
          </Tooltip>
          <Tooltip placement="bottom" title="Ley de Espectáculos Públicos: Infórmate sobre los beneficios, requisitos y procesos relacionados con la Ley de Espectáculos Públicos en Medellín.">
            <NavLink
              to="/lep"
              className={({ isActive }) => isActive ? "selected nav-item" : "nav-item"}
            >
              <FaBookOpen className="nav-icon" />
              <span>LEP</span>
            </NavLink>
          </Tooltip>
          <Tooltip placement="bottom" title="Conoce más sobre los estímulos y procesos de PP en Medellín">
            <NavLink
              to="/pp"
              className={({ isActive }) => isActive ? "selected nav-item" : "nav-item"}
            >
              <FaHandPointUp className="nav-icon" />
              <span>PP</span>
            </NavLink>
          </Tooltip>
        </nav>

        <div className="navbar-toggle" onClick={toggleMenu}>
          <div className={`bar ${isOpen ? "open" : ""}`} />
          <div className={`bar ${isOpen ? "open" : ""}`} />
          <div className={`bar ${isOpen ? "open" : ""}`} />
        </div>
      </div>
    </header>
  );
};
